// src/components/MaintenanceLists/BikePhoto.js
import React from 'react';
import { Card, Button } from 'react-bootstrap';

/**
 * BikePhoto component displays the motorcycle's photo
 * 
 * @param {Object} props - Component props
 * @param {Object} props.bike - The bike data object
 * @param {boolean} props.isOwner - Whether the current user is the bike owner
 * @param {Function} props.onEditClick - Function to handle photo editing
 * @returns {JSX.Element} Rendered component
 */
const BikePhoto = ({ bike, isOwner, onEditClick }) => {
  return (
    <>
      {bike.photo ? (
        <Card className="listing-photo-card mb-4 border-0 overflow-hidden">
          <Card.Img 
            src={bike.photo} 
            alt={bike.nickname || `${bike.year} ${bike.make} ${bike.model}`}
            className="listing-photo-image responsive-photo"
          />
        </Card>
      ) : (
        isOwner && (
          <Card 
            className="no-photo-card mb-4 bg-light border-dashed responsive-banner"
          >
            <Card.Body className="d-flex align-items-center justify-content-center">
              <Button 
                variant="outline-secondary" 
                onClick={onEditClick}
                className="px-4 py-2"
              >
                <i className="bi bi-camera me-2"></i>
                Add Photo
              </Button>
            </Card.Body>
          </Card>
        )
      )}
    </>
  );
};

export default BikePhoto;